<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showTablaGoleadores"
    scrollable
    size="lg"
    title="Tabla de posiciones"
    hide-footer
  >
    <vue-excel-xlsx
      :data="listTablaGoleadores"
      :columns="columns"
      :file-name="'listado'"
      :file-type="'xlsx'"
      :sheet-name="'sheetname'"
      class="excel"
    >
      Exportar Excel
    </vue-excel-xlsx>
    <table class="table">
      <thead class="thead-dark">
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Nombre</th>
          <th scope="col">Equipo</th>
          <th scope="col">Categoria</th>
          <th scope="col">Goles</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in listTablaGoleadores" :key="item.id">
          <th scope="row" style="color:gray">{{ index + 1 }}</th>
          <td>
            <b-avatar size="32" :src="item.foto_jug" />
          </td>
          <td class="text-capitalize">{{ item.nombreCom }}</td>
          <td>{{ item.equipo }}</td>
          <td>{{ item.categoria }}</td>
          <td
            style="font-size:20px;text-align: center; background-color: #e8e226"
          >
            {{ item.total_goles }}
          </td>
        </tr>
      </tbody>
    </table>
  </b-modal>
</template>
<script>
import { BModal, BAvatar } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BModal,
    BAvatar,
  },
  props: {
    listTablaGoleadores: Array,
  },
  setup() {
    const columns = ref([
      {
        label: 'Apellidos',
        field: 'apellidos',
      },
      {
        label: 'Nombres',
        field: 'nombres',
      },
      {
        label: 'Equipo',
        field: 'equipo',
      },
      {
        label: 'Categoria',
        field: 'categoria',
      },
      {
        label: 'Total',
        field: 'total_goles',
      },
    ])
    return {
      columns,
    }
  },
}
</script>
<style scoped>
.table th,
.table td {
  padding: 0.5rem;
}
.excel {
  color: #ede5e5;
  background-color: #243e3e;
  border: 4px;
  border-radius: 4px;
  font-size: 11px;
  padding: 2px 4px 2px 5px;
  margin-right: 12px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
